// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingIcon_loading__61sCB"};